<template>
  <div class="container container-container d-flex flex-column align-items-center justify-content-center">
    <div class="py-3 d-grid gap-3 d-flex align-items-center flex-column mb-5">
      <div class="welcome-logo">
        <img src="@/assets/images/logo-8.png" class="img-fluid" alt="eShopCommand">
      </div>
      <div class="display-5">{{ tagLine }}</div>
    </div>
    <login-button next-route="home" />
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useStore } from "vuex"
import LoginButton from "@/app/components/LoginButton.vue";
const store = useStore();
// const appName = computed(() => store.state.appName);
const tagLine = computed(() => store.state.tagLine);

</script>


<style scoped lang="scss">
.welcome-logo {
  width: 100%;
  max-width: 150px;
}
</style>
